import * as TYPE from '../types';
import axios from 'axios';
import { api } from '../static';
import { toast } from 'react-toastify';

export function rolesDataFetched(roles) {
  return {
    type: TYPE.ROLES_DATA_FOUND,
    payload: {
      data: roles,
    },
  };
}

export function getRolesData(params, headers) {
  return (dispatch) => {
    axios
      .get(process.env.BASE_URL + api.rolesData, {
        headers: headers,
        params: params,
      })
      .then((res) => {
        dispatch(rolesDataFetched(res.data.data.roles));
      })
      .catch((err) => {
        dispatch({
          type: TYPE.ROLES_DATA_ERROR,
          payload: err?.response,
        });
      });
  };
}

export function addNewRole(headers, closeModal, setSearchFlag, some) {
  return (dispatch) => {
    axios
      .post(process.env.BASE_URL + api.addRole, some, {
        headers: headers,
      })
      .then((res) => {
        dispatch({ type: TYPE.NEW_ROLE_ADD_SUCCESS });
        setSearchFlag((searchFlag) => !searchFlag);
        // console.log("Add Role Success");
        toast.success('Role Added', {
          position: 'top-center',
          autoClose: 1500,
        });
        closeModal();
      })
      .catch((err) => {
        console.log(err);
        toast.error('Operation Failed', {
          position: 'top-center',
          autoClose: 1500,
        });
        dispatch({ type: TYPE.NEW_ROLE_ADD_ERROR });
      });
  };
}

export function updateRole(headers, closeModal, setSearchFlag, temp) {
  return (dispatch) => {
    axios
      .post(process.env.BASE_URL + api.updateRole, temp, {
        headers: headers,
      })
      .then((res) => {
        dispatch({ type: TYPE.UPDATE_ROLE_SUCCESS });
        setSearchFlag((searchFlag) => !searchFlag);
        // console.log("Add Role Success");
        toast.success('Role Added', {
          position: 'top-center',
          autoClose: 1500,
        });
        closeModal();
      })
      .catch((err) => {
        console.log(err);
        toast.error('Operation Failed', {
          position: 'top-center',
          autoClose: 1500,
        });
        dispatch({ type: TYPE.UPDATE_ROLE_ERROR });
      });
  };
}
